"use client"
import { useEffect, useState } from "react";
import FooterNavigationClient from "./index-client";
import FooterNavigationServer from "./index-server";

const FooterNavigation = () => {

    const [loading, setLoading] = useState(true);
    const [hydrated, setHydrated] = useState(false);
    useEffect(() => {
        setHydrated(true);
    }, []);

    return (
        <>
            {hydrated ?
                <FooterNavigationClient />
                : <FooterNavigationServer />
            }
        </>
    );
}

export default FooterNavigation;